var render = function () {
  var _vm$data, _vm$data2, _vm$data5, _vm$data6, _vm$data7, _vm$data7$content;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "유통데이터 활용 경진대회 주요자료",
            "src": "/images/sub/sub-visual-circulation.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm.data ? _c('div', [_c('v-row', {
    attrs: {
      "align-md": "center"
    }
  }, [_c('v-col', [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-chip', {
    staticClass: "font-weight-extrabold",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "secondary"
    }
  }, [_c('i', {
    staticClass: "icon icon-award mr-4px"
  }), _c('span', [_vm._v(_vm._s((_vm$data = _vm.data) === null || _vm$data === void 0 ? void 0 : _vm$data.awardName))])])], 1), _c('v-col', [_c('h5', {
    staticClass: "tit tit--xxs"
  }, [_vm._v(_vm._s((_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : _vm$data2.subject))])])], 1)], 1), _c('v-col', {
    staticClass: "d-flex justify-end mt-12px mt-md-0",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "800",
      "content-class": "rounded-0"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "min-w-lg-180px justify-space-between",
          attrs: {
            "x-large": "",
            "outlined": "",
            "color": "secondary"
          }
        }, on), [_vm._v(" 분석자료 받아보기 "), _c('icon-down', {
          staticClass: "icon--size-small ml-12px"
        })], 1)];
      }
    }, {
      key: "default",
      fn: function fn(dialog) {
        var _vm$data3, _vm$data4;
        return [_c('v-card', {
          attrs: {
            "tile": "",
            "flat": ""
          }
        }, [_c('v-toolbar', {
          attrs: {
            "tile": "",
            "flat": ""
          }
        }, [_c('v-spacer'), _c('v-toolbar-title', {
          staticClass: "font-size-18 font-weight-extrabold line-height-11 ml-24px d-md-none"
        }, [_vm._v("분석자료 받아보기")]), _c('v-spacer'), _c('v-btn', {
          staticClass: "transparent",
          attrs: {
            "x-large": "",
            "icon": ""
          },
          on: {
            "click": function click($event) {
              dialog.value = false;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey darken-4",
            "size": "24"
          }
        }, [_vm._v("mdi-close")])], 1)], 1), _c('div', {
          staticClass: "px-30px pb-30px px-md-50px pt-md-10px pb-md-50px px-lg-60px pt-lg-12px pb-lg-80px"
        }, [_c('div', {
          staticClass: "mb-30px mb-md-40px d-none d-md-block"
        }, [_c('div', {
          staticClass: "font-size-md-24 font-weight-extrabold line-height-11 text-center"
        }, [_vm._v("분석자료 받아보기")])]), [_c('div', {
          domProps: {
            "innerHTML": _vm._s((_vm$data3 = _vm.data) === null || _vm$data3 === void 0 ? void 0 : _vm$data3.content2)
          }
        }), _c('v-layout', {
          staticClass: "mt-20px mt-md-40px",
          attrs: {
            "justify-center": ""
          }
        }, [_c('v-btn', {
          staticClass: "min-w-lg-180px justify-space-between",
          attrs: {
            "href": (_vm$data4 = _vm.data) === null || _vm$data4 === void 0 ? void 0 : _vm$data4.link,
            "target": "_blank",
            "x-large": "",
            "color": "secondary"
          }
        }, [_vm._v(" 교육접수 바로가기 "), _c('icon-arrow-rounded', {
          staticClass: "icon--size-small ml-12px",
          attrs: {
            "direction": "right"
          }
        })], 1)], 1)]], 2)], 1)];
      }
    }], null, false, 42366745)
  })], 1)], 1), _c('table', {
    staticClass: "board-view mt-12px mt-md-20px"
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', [_c('h5', {
    staticClass: "txt font-weight-extrabold"
  }, [_vm._v(_vm._s((_vm$data5 = _vm.data) === null || _vm$data5 === void 0 ? void 0 : _vm$data5.name))])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-view mr-4px"
  }), _vm._v(" " + _vm._s((_vm$data6 = _vm.data) === null || _vm$data6 === void 0 ? void 0 : _vm$data6.viewCount) + " ")])], 1)], 1)], 1)]), _c('tr', [_c('td', {
    staticClass: "content_box",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm$data7 = _vm.data) === null || _vm$data7 === void 0 ? void 0 : (_vm$data7$content = _vm$data7.content) === null || _vm$data7$content === void 0 ? void 0 : _vm$data7$content.replace(/\n/g, '<br>'))
    }
  })])])]), _c('v-layout', {
    staticClass: "mt--md",
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "grey lighten-3"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("리스트")])])], 1)], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }